import React from 'react';
import SelectPopup from './SelectPopup';
import { resetModuleByRFID as reset } from '../../../service/command';
import { filterDetectModules, filterOperatorModules } from '../../../js/utils';

const modules = [
  'cpu1',
  'cpu2',
  'rtc',
  'radar',
  'geo'
];

export default function Reboot() {
  let targets = [...modules];

  targets = filterDetectModules(filterOperatorModules(targets));

  return (
    <SelectPopup
      title="重置"
      modules={targets}
      defaultSelectValue={targets[0]}
      onConfirm={(module) => {
        return reset(module);
      }}
    />
  );
}
